import React, { Component } from 'react';
import {
  Nav,
  NavItem,
  TabPane,
  TabContent,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import cn from 'classnames';
import { array, bool } from 'prop-types';
import Card from './Card';

class CardNavTabs extends Component {
  static propTypes = {
    navItems: array.isRequired,
    headerOffset: bool,
  };

  static defaultProps = {
    navItems: [],
    headerOffset: false,
  };
  constructor(props) {
    super(props);

    this.state = {
      activeTab: props.activeTab ? props.activeTab : 1,
      dropdownOpen: false,
      dropdownTitle: '',
    };
  }

  componentDidMount() {
    const { navItems, activeTab } = this.props;

    if (navItems.length > 0) {
      this.setState(() => ({
        dropdownTitle: navItems[0].props.title,
        activeTab: activeTab ? activeTab : 1,
      }));
    }
  }

  renderControls = navItems => {
    return (
      <Nav tabs className="nav-tabs_big">
        {navItems.length > 0 &&
          navItems.map((navItem, index) => (
            <NavItem
              key={`${navItem.props.title}_${index}`}
              className={cn({ active: this.state.activeTab === index + 1 })}
              onClick={() => {
                this.toggleTab(index + 1, navItem.props.title);
              }}
            >
              {navItem}
            </NavItem>
          ))}
      </Nav>
    );
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const prevTab = this.props.activeTab;
    const nextTab = nextProps.activeTab;
    if(prevTab !== nextTab) {
      this.toggleTab(nextTab, nextProps.navItems[nextTab - 1].props.title);
    }
  }

  renderDropdown = navItems => {
    return (
      <Dropdown
        isOpen={this.state.dropdownOpen}
        toggle={this.toggleDropdown}
        className="nav-tabs-collapse"
      >
        <DropdownToggle
          tag="span"
          data-toggle="dropdown"
          aria-expanded={this.state.dropdownOpen}
          className="dropdown-toggle"
        >
          {this.state.dropdownTitle}
        </DropdownToggle>
        <DropdownMenu>
          {navItems.length > 0 &&
            navItems.map((navItem, index) => (
              <DropdownItem
                key={`DropdownItem_${navItem.props.title}_${index}`}
                disabled={this.state.activeTab === index + 1}
                onClick={() => {
                  this.toggleTab(index + 1, navItem.props.title);
                }}
                className="no-padding"
              >
                {navItem}
              </DropdownItem>
            ))}
        </DropdownMenu>
      </Dropdown>
    );
  };

  renderBtns = btnItems => {
    const {showAlert, btnProps} = this.props;
    return (
      <div className="nav-btns">
        {btnItems.map((BtnItem, index) => <BtnItem key={index} showAlert={showAlert} {...btnProps}/>)}
      </div>
    );
  };

  toggleTab = (tab, name) => {
    if (this.state.activeTab !== tab) {
      if(this.props.onTabChange) {
        this.props.onTabChange(tab);
      }
      this.setState(() => ({ activeTab: tab, dropdownTitle: name }));
    }
  };

  toggleDropdown = () => {
    this.setState(prevState => ({ dropdownOpen: !prevState.dropdownOpen }));
  };

  render() {
    const {
      children = [],
      navItems,
      btnItems,
      headerOffset,
      showAlert,
      tabProps,
      btnProps,
      activeTab,
      onTabChange,
      ...attributes
    } = this.props;

    const { activeTab: tabActive } = this.state;
    return (
      <Card {...attributes} activetab={tabActive}>
        <Card.Header className={cn('no-padding', { 'card-header-offset': headerOffset })}>
          {this.renderControls(navItems)}
          {this.renderDropdown(navItems)}
          {btnItems && btnItems.length ? this.renderBtns(btnItems) : null}
        </Card.Header>

        <TabContent activeTab={this.state.activeTab}>
          {Array.isArray(children)
            ? children.map((TabContent, index) => (
                <TabPane
                  key={`TabContent_${index}`}
                  className={cn({ active: this.state.activeTab === index + 1 })}
                >
                  {React.cloneElement(TabContent, {tabProps})}
                </TabPane>
              ))
            : React.cloneElement(children, {tabProps})}
        </TabContent>
      </Card>
    );
  }
}

export default CardNavTabs;
